<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
//折柱混合
// import echarts from 'echarts'
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "./mixins/resize";
// import resize from "./mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "300px",
    },
    chartData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      // this.chart = echarts.init(this.$el, "macarons");
      this.chart = echarts.init(this.$el);

      this.setOptions(this.chartData);
    },
    setOptions({
      titleData,
      lineName,
      barName,
      xAxisData,
      lineData,
      barData,
    } = {}) {
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        // title: {
        //   text: titleData,
        //   left: "center",
        // },
        // toolbox: {
        //   feature: {
        //     dataView: { show: true, readOnly: false },
        //     magicType: { show: true, type: ["line", "bar"] },
        //     restore: { show: true },
        //     saveAsImage: { show: true },
        //   },
        // },
        legend: {
          data: [barName, lineName],
          orient: "horizontal",
          top: "bottom",
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData,
            axisPointer: {
              type: "shadow",
            },
            axisLabel: {
              interval: "auto",
              rotate: 15,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: barName,
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
          },
          {
            type: "value",
            name: lineName,
            min: 0,
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: barName,
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value + " 元";
              },
            },
            data: barData,
          },
          {
            name: lineName,
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + " 元";
              },
            },
            data: lineData,
          },
        ],
      });
    },
  },
};
</script>
